import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    metadataPreviewOpenComplete,
    metadataPreviewOpenStart,
    metadataPreviewPanelOpenStart
} from './metadata-preview.actions';
import { PreviewService } from '../../../services';
import { AppState } from '../../app.model';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { MetadataPreviewActionsService } from './metadata-preview-actions.service';

@Injectable()
export class MetadataPreviewEffects {

    public togglePanel$ = createEffect(() => this.actions$
        .pipe(ofType(metadataPreviewPanelOpenStart),
            withLatestFrom(this.store),
            map(([action, store]) => {
                    const name = action.name;

                    const listDefinition = store.listDefinitions.definitionsByType[ store.obiektList.listDefinitionType ];
                    const type = listDefinition.metadataPanelDefinitions
                        .find(definition => definition.name === name).procedureName;

                    const id = store.obiektList.currentList.data.listData.metadataPreview.id;

                    let previewResponse: Observable<object>;
                    // Dla raportów spójności przekazujemy aktualne dane z filtra. Dla reszty używamy generycznego mechanizmu
                    switch (name) {
                        case 'Raporty spójności': {
                            const raportSpojnosciMetadataIdSufiks = '_RaportSpojnosci';
                            const raportSpojnosciFilter = store.obiektList.currentList.data.filterData.values
                                .find(x => x.metadataId.endsWith(raportSpojnosciMetadataIdSufiks));

                            const raportSpojnosciFilterValue = raportSpojnosciFilter
                                ? raportSpojnosciFilter.value : null;
                            previewResponse = this.previewService.previewRaportySpojnosci(id, raportSpojnosciFilterValue);
                            break;
                        }

                        default: {
                            previewResponse = this.previewService.preview(type, id, listDefinition.obiektType);
                        }
                    }
                    previewResponse.subscribe(x => {
                        this.store.dispatch(metadataPreviewOpenComplete({panel: {name: name, open: true, data: x, state: action.state}}));
                    });
                }
            )), {dispatch: false});

    public toggle$ = createEffect(() => this.actions$
        .pipe(ofType(metadataPreviewOpenStart),
            withLatestFrom(this.store),
            map(([action, store]) => {
                let panels = store.obiektList.currentList.data.listData.metadataPreview.previousPanels;
                if (panels.length === 0) {
                    const type = store.listDefinitions.definitionsByType[ store.obiektList.listDefinitionType ].metadataPanelDefinitions;
                    panels = [type[ 0 ].name];
                }
                for (const panel of panels) {
                    this.metadataPreviewActionsService.openPanelAsync(panel);
                }
            })), {dispatch: false});

    constructor(private actions$: Actions,
                private previewService: PreviewService,
                private metadataPreviewActionsService: MetadataPreviewActionsService,
                private store: Store<AppState>) {
    }
}
